module.exports = __webpack_public_path__ + "static/media/thumb6.bd5e0714.jpg";